import React, { useEffect, useState } from "react";
import { authService } from "../services/authService";

export const verifyCallbackSession = async (search: string): Promise<string | null> => {
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const refreshToken = params.get("refresh_token");

  if (!token) {
    return "The authentication service did not return a session token. Please sign in again.";
  }

  authService.setToken(token);
  if (refreshToken) {
    authService.setRefreshToken(refreshToken);
  }

  const user = await authService.getUserInfo();
  if (!user) {
    authService.clearAuth();
    return "We could not verify your session for this audience. Please sign in again.";
  }
  return null;
};

export const scrubCallbackCredentials = (
  location: Pick<Location, "pathname" | "search" | "hash"> = window.location,
  history: Pick<History, "state" | "replaceState"> = window.history
): void => {
  const params = new URLSearchParams(location.search);
  const hadToken = params.has("token");
  const hadRefreshToken = params.has("refresh_token");
  if (!hadToken && !hadRefreshToken) return;
  params.delete("token");
  params.delete("refresh_token");
  const query = params.toString();
  history.replaceState(
    history.state,
    "",
    `${location.pathname}${query ? `?${query}` : ""}${location.hash}`
  );
};

export const AuthCallback = () => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    const completeSignIn = async () => {
      const callbackSearch = window.location.search;
      scrubCallbackCredentials();
      const verificationError = await verifyCallbackSession(callbackSearch);
      if (!active) return;
      if (verificationError) {
        setError(verificationError);
        return;
      }

      window.location.href = "/";
    };

    void completeSignIn();
    return () => { active = false; };
  }, []);

  if (error) {
    return (
      <main className="app-shell unauth">
        <div className="card auth-card" role="alert">
          <h1>Unable to complete sign-in</h1>
          <p>{error}</p>
          <button className="primary-btn" type="button" onClick={() => authService.redirectToLogin()}>
            Try Again
          </button>
        </div>
      </main>
    );
  }

  return <div className="card">Completing sign-in...</div>;
};
